import { LessonsState } from '@/store/lessons/types';

const state: LessonsState = {
  lessons: [],
};

export default state;
